import '../../../assets/css/style.min.css'
import * as Quill from 'quill'
import { form, g, grv_v3, grv_v4, grv_v5, initU, log, openModal_v2, t } from '../../../../../utils'
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { addDoc, collection, doc, getDoc, getDocs, getFirestore, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { firebaseConfig } from '../../../components/config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const firestore = getFirestore()

onAuthStateChanged(auth, async (user) => {
    if (user) {
        initU(user)

        var targetPolicy = ""

        function edit(id) {
            targetPolicy = id

            openModal_v2("modal-full-screen", () => {
                location.reload()
            })
        }

        const accordion = (policySnapshot) => {
            const policyData = policySnapshot.data()

            g("_policies").appendChild(t(`<li class="accordion-v2__item  js-accordion__item">
                <button class="reset accordion-v2__header padding-y-sm padding-x-md js-tab-focus width-100%"
                type="button">
                    <span class="text-md">${policyData.name}</span>

                    <span><button id="${policySnapshot.id}"></button></span>

                    <svg class="icon accordion-v2__icon-arrow no-js:is-hidden" viewBox="0 0 20 20">
                        <g class="icon__group" fill="none" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round">
                        <line x1="3" y1="3" x2="17" y2="17" />
                        <line x1="17" y1="3" x2="3" y2="17" />
                        </g>
                    </svg>
                </button>

                <div class="accordion-v2__panel padding-top-xxxs padding-x-md padding-bottom-md js-accordion__panel">
                    <div class="text-component line-height-md text-space-y-md">${policyData.content}</div>
                </div>
            </li>`));

            g(policySnapshot.id).addEventListener("click", () => edit(policySnapshot.id))
        }

        const policiesQs = await getDocs(collection(firestore, "policies"))
        policiesQs.docs.forEach(policySnapshot => accordion(policySnapshot))

        var editor = new Quill(".editor", {
            modules: {
                toolbar: [
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['link'],
                    ['blockquote', 'code-block'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction
                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['clean']                                         // remove formatting button
                ]
            },
            placeholder: 'Empty document...',
            theme: 'snow'  // or 'bubble'
        })

        form("policy_form", async (data) => {
            var policy = await addDoc(collection(firestore, "policies"), {
                name: data.name,
                timestamp: serverTimestamp()
            })

            edit(policy.id)
        })

        g('btn_update').addEventListener("click", async (el) => {
            el.target.disabled = true

            await setDoc(doc(firestore, `policies/${targetPolicy}`), {
                content: `<div class="text-component">${editor.root.innerHTML}</div>`,
                lastUpdated: serverTimestamp()
            }, { merge: true }).then(() => {
                alert("Updated succefully!")
                location.reload()
            }).catch((e) => {
                alert(e.message)
            })
        })

        require("../../../assets/js/scripts")
    } else { }
})






